// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PageStyle } from "@insite/mobius/Page";
import { getProp } from "@insite/mobius/utilities";
import { mobileTippyStyle } from "@turnerBlueprint/App/ComponentExtensions/Tippy/TippyPopupExtensions";
import { ToasterSlots } from "@turnerBlueprint/MobiusOverrides/Toast/Toaster";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { xBaseTheme } from "@turnerBlueprint/XDL/types";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

export const zIndexLoadingOverlay = 1500;

export const hideLoadingOverlay = css`
    #react-app.remove-ootb-spinners {
        div[data-test-selector="loadingOverlaySpinner"],
        svg[class^="LoadingSpinnerStyle"] {
            visibility: hidden;
            width: 0;
            height: 0;
            position: absolute;
            top: -10000px;
        }
    }
`;

export const xngLoadingOverlayUtilitiesStyles = css`
    #xng-loading-overlay {
        width: 100%;
        position: fixed;
        height: 100%;
        z-index: ${zIndexLoadingOverlay};
        top: 0;
        bottom: 0;
        @media print {
            display: none;
        }
    }
`;

export default {
    css: css`
        ${hideLoadingOverlay}
        ${xngLoadingOverlayUtilitiesStyles}
        ${mobileTippyStyle}
        
        body {
            line-height: 1;
            /* Better Font Rendering */
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-family: ${fontConfig.fontFamily};

            &:after {
                transition: all 0.2s linear;
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                z-index: ${getProp("theme.zIndex.shade")};
                width: 100%;
                height: 100%;
                pointer-events: none;
            }

            &.shade {
                &:after {
                    background-color: ${color("common.ui7", 0.7)};
                }
            }
        }

        @media print {
            .hideForPrint {
                display: none;
            }
            .hideForPrint * {
                display: none;
            }
            .showForPrint {
                display: block;
            }
        }

        @media screen {
            .showForPrint {
                display: none;
            }
        }

        ${PageStyle}:has([data-test-selector="pageBreadcrumbs"]) {
            padding-top: 12px;
            padding-bottom: 0;
        }

        ${ToasterSlots}:empty {
            display: none;
        }

        // XNG-Changes: XSD-16416
        #snapengage-button {
            opacity: 0 !important;
            pointer-events: none !important;
        }
    `,
} as xBaseTheme["globalStyle"];
